"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const react_1 = __importDefault(require("react"));
const Text = ({ as, children, className = '', ...props }) => {
    const Component = as ?? 'span';
    return (react_1.default.createElement(Component, { className: className, ...props }, children));
};
exports.Text = Text;
